export default "__VITE_ASSET__CyuyvN8p__"